import React from "react";
import {autorun} from "mobx";
import EsriScaleBar from "@arcgis/core/widgets/ScaleBar";
import EsriScaleBarViewModel from "@arcgis/core/widgets/ScaleBar/ScaleBarViewModel";

import {UiState} from "../../ui-state";

import {ScaleBarConfiguration} from "../../config/scalebar-configuration";
import {observer} from "mobx-react";

interface ScalebarProps {
    config: ScaleBarConfiguration;
    view: __esri.MapView | __esri.SceneView | undefined;
    onLoad?: (scaleBarViewModel: EsriScaleBarViewModel) => any;
    uiStore: UiState;
}

@observer
export class ScaleBar extends React.Component<ScalebarProps, any> {
    watchHandles: any[] = [];
    autorunDisposers: any[] = [];
    scaleBar: any;
    scaleBarRef: any;
    constructor(props: ScalebarProps) {
        super(props);
        this.state = {
            viewModel: null,
            isLoading: true
        };
        this.scaleBarRef = React.createRef();
    }

    componentDidMount(): void {
        // rerun until map view is ready and layer list view model is loaded
        this.autorunDisposers.push(autorun((reaction: any) => {
            if (this.props.uiStore.widgets.has("scalebar")) {
                reaction.dispose(); // stop autorun
                return;
            }
            const {view} = this.props;
            if (!view) {
                return;
            }
            const scaleBar = this.loadScaleBar(view);
            if (!scaleBar) {
                return;
            }
            /* console.log(scaleBar);
            this.watchHandles.push(
                scaleBar.viewModel.watch("view.zoom",
                    (newValue: any, oldValue: any, propertyName: string, target: any) => {
                    this.setState({viewModel: target});
                    console.log('handle view');
                    console.log(target);
                })
            );*/
            this.setState({
                isLoading: false,
                viewModel: scaleBar.viewModel
            });
            this.props.uiStore.addWidget("scalebar", this);

            if (this.props.onLoad) {
                // call the hook
                this.props.onLoad(scaleBar.viewModel);
            }
            reaction.dispose();
        }));
    }

    componentWillUnmount(): void {
        const {uiStore} = this.props;
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
        this.autorunDisposers.forEach((disposer: any) => {
            disposer();
        });
        this.autorunDisposers.length = 0;
        uiStore.removeWidget("scalebar");
    }

    loadScaleBar(view: __esri.MapView | __esri.SceneView): __esri.ScaleBar {
        const config = this.props.config as __esri.ScaleBarProperties;
        config.container = this.scaleBarRef.current;
        const props = {
            view,
            ...config
        };
        return new EsriScaleBar(props);
    }

    render(): JSX.Element | null {
        return (
            <div className="scalebarWrapper" ref={this.scaleBarRef}/>
        );
    }
}
